<template>
  <div>
    <span v-if="status == 21" class="badge bdg-draft">Lead</span>
    <span v-if="status == 22" class="badge bdg-new">Lead quoted</span>
    <span v-if="status == 23" class="badge bdg-amended">Submitted</span>
    <span v-if="status == 24" class="badge bdg-not-proceeding"
      >Can not Assist</span
    >
    <span v-if="status == 25" class="badge bdg-lmtcb-1">LMTCB 1</span>
    <span v-if="status == 26" class="badge bdg-lmtcb-2">LMTCB 2</span>
    <span v-if="status == 27" class="badge bdg-lmtcb-3">LMTCB 3</span>
    <span v-if="status == 28" class="badge bdg-type-2">Infor. Only</span>
    <span v-if="status == 29" class="badge bdg-archived">Archived</span>
    <span v-if="status == 30" class="badge bdg-request-docs-for-app"
      >Requ. DOCs for App</span
    >
    <span v-if="status == 31" class="badge bdg-booked-info-session"
      >Booked Info Session</span
    >
  </div>
</template>
<script>
export default {
  name: 'WDLeadsStatusBadge',
  props: ['status']
}
</script>
